module.exports = __webpack_public_path__ + "static/gallery-8-7a09e6920f123f2416f8f1df65ec4593.jpg";